'use client';

import { cacheCelloReferralCodeFromSearchParams } from '@modules/cello-referral';
import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

/**
 * Captures the Cello referral code (`ucc`) on App Router pages.
 *
 * Cello appends the parameter to whatever destination URL its dashboard is configured
 * with, and that destination is not guaranteed to be a Pages Router route — the invite
 * and onboarding-v2 flows both live here. Without this, a referral link landing on an
 * App Router page loses the code before signup ever reads it (ACT-2224).
 *
 * Mounted alongside `_app`'s equivalent rather than replacing it: the two routers own
 * separate page trees, and only the one that rendered the landing page runs.
 */
export function CelloReferralCapture() {
  const searchParams = useSearchParams();

  useEffect(() => {
    cacheCelloReferralCodeFromSearchParams(searchParams);
  }, [searchParams]);

  return null;
}
